"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MySpecialPurchaseInit = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var hsMySpecialProduct_1 = require("../../model/hsMySpecialProduct");
var service_1 = require("../../../library/base/service");
var MySpecialPurchaseInit = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(MySpecialPurchaseInit, _super);
    function MySpecialPurchaseInit() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '特约产品初始化';
        _this.code = '105035';
        _this.desc = '特约产品初始化';
        _this.requestParams = new hsMySpecialProduct_1.MySpecialPurchaseInitRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return MySpecialPurchaseInit;
}(service_1.BaseService));
exports.MySpecialPurchaseInit = MySpecialPurchaseInit;
//# sourceMappingURL=mySpecialPurchaseInit.js.map